export default {
  // 新增采购订单
  insertYcPurchaseOrder: '/ygsjzs/ycnPurchaseOrder/insertYcnPurchaseOrder',
  // 修改采购订单
  updateYcPurchaseOrder: '/ygsjzs/ycnPurchaseOrder/updateYcnPurchaseOrder',
  // 删除采购订单
  deleteYcPurchaseOrder: '/ygsjzs/ycnPurchaseOrder/deleteYcnPurchaseOrder',
  // 查询采购订单详情
  selectYcPurchaseOrderByOrderId: '/ygsjzs/ycnPurchaseOrder/selectYcnPurchaseOrderByOrderId',
  // 查询采购订单列表
  selectYcPurchaseOrderByList: '/ygsjzs/ycnPurchaseOrder/selectYcnPurchaseOrderByPage',
  // 审批采购合同
  approveYcnPurchaseOrder: '/ygsjzs/ycnPurchaseOrder/approveYcnPurchaseOrder',
  // 采购订单统计
  selectYcPurchaseOrderCount: '/ygsjzs/ycnSupplierPrice/selectYcnPurchaseOrderCount',
  // 采购合同统计（小程序）
  selectYcnPurchaseOrder: '/ygsjzs/ycnPurchaseOrder/selectYcnPurchaseOrder',
  // 采购合同统计导出
  exportYcnPurchaseOrder: '/ygsjzs/ycnPurchaseOrder/exportYcnPurchaseOrder'
}
